import React from 'react';
import { Outlet } from 'react-router-dom';

function ParticipantWithdrawalScene() {
  return <Outlet />;
}

export default ParticipantWithdrawalScene;
